"use client";

import { useEffect } from "react";
import { storeReferralCode } from "@/lib/referral-capture";

/** Stores the `?ref=` code of any page a visitor lands on (lib/referral-capture). Renders nothing. */
export function RefCapture() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) storeReferralCode(ref);
  }, []);
  return null;
}
